import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner, Table } from '@dixa/lib-shared-habla';
import styles from './tableLoadingRow.module.scss';
export const TableLoadingRow = ({ colSpan }) => (_jsx(Table.Tr, { children: _jsxs(Table.Td, Object.assign({ align: "center", colSpan: colSpan }, { children: [_jsx(Spinner, {}), _jsx("div", Object.assign({ className: styles.text }, { children: "Loading..." }))] })) }));
